export default __webpack_public_path__ + "static/media/table.f573260e.svg";